import type { ReactElement } from 'react';
import { Link } from 'react-router';
import { formatCount } from '@/shared/lib';

interface SummaryCardProps {
  readonly label: string;
  readonly count: number;
  readonly unit: string;
  /** 작은 글씨 — "검토 대기 3 · 수정 요청 4" 처럼 나눈 수. */
  readonly detail: string;
  /** 있으면 카드 전체가 그 목록으로 가는 링크다. */
  readonly to?: string;
}

const CARD_CLASS =
  'flex min-w-0 flex-col gap-1 rounded-2xl border border-foreground/[0.06] bg-card p-5 shadow-[0_1px_2px_rgba(0,0,0,0.03)]';

/** 숫자 카드 하나 — 큰 수와 단위, 아래에 나눈 수. */
export const SummaryCard = ({ label, count, unit, detail, to }: SummaryCardProps): ReactElement => {
  const body = (
    <>
      <span className="text-sm text-muted-foreground">{label}</span>
      <span className="text-3xl font-semibold tabular-nums tracking-[-0.02em]">
        {formatCount(count)}
        <span className="ml-0.5 text-base font-medium">{unit}</span>
      </span>
      <span className="truncate text-xs text-muted-foreground">{detail}</span>
    </>
  );
  return to ? (
    <Link
      to={to}
      aria-label={`${label} ${formatCount(count)}${unit}`}
      className={`${CARD_CLASS} transition-colors hover:bg-foreground/[0.02]`}
    >
      {body}
    </Link>
  ) : (
    <div className={CARD_CLASS}>{body}</div>
  );
};
